module.exports = __webpack_public_path__ + "static/EuclidTriangle-Medium-WebS-2b2e984b8858f6b2749d9f0fa155897b.woff2";